import { render, staticRenderFns } from "./classLearing.vue?vue&type=template&id=172f516c&scoped=true"
import script from "./classLearing.vue?vue&type=script&lang=js"
export * from "./classLearing.vue?vue&type=script&lang=js"
import style0 from "./classLearing.vue?vue&type=style&index=0&id=172f516c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172f516c",
  null
  
)

export default component.exports